module.exports = __webpack_public_path__ + "img/1.6a68fba9.png";